import { UploadedPolicyGetAllUseCase } from '../../../application';

export default class UploadedPolicyGetAllService {
    constructor() {}

    async execute(event) {
        const request = await UploadedPolicyGetAllUseCase(event);

        return request;
    }
}
